<!-- Two root nodes on purpose: the parent lays its children out in a column, so wrapping
     these in an element of our own would change that spacing. -->
<template>
  <BaseInputLabel
    :text="$t('admin.invoices.image')"
    :info="$t('admin.invoices.image_description')"
  />
  <BaseUpload
    preset="company_logo"
    :text="$t('global.actions.upload')"
    :image="currentImageUrl"
    withImagePreview
    withDelete
    @uploadResults="handleImageUpload"
    @delete="handleImageDelete"
  />
</template>

<script
  lang="ts"
  setup
>
import { inject, type Ref } from 'vue';
import type { CloudinaryResponse } from '@/components/base-upload/index.vue';
import type { InvoiceFormData } from './useInvoices';

const formData = inject<InvoiceFormData>('formData')!;
const currentImageUrl = inject<Ref<string>>('currentImageUrl')!;

const handleImageUpload = (uploadResults: CloudinaryResponse) => {
  formData.invoiceImage = `${uploadResults.resource_type}/${uploadResults.type}/${uploadResults.public_id}.${uploadResults.format}`;
  currentImageUrl.value = uploadResults.secure_url;
};

const handleImageDelete = () => {
  formData.invoiceImage = '';
  currentImageUrl.value = '';
};
</script>
